// The 8 directions the walk and the ride face, with no Phaser in it so node tests can import it (walkAnim.js
// re-exports it). The generated art faces the viewer's LEFT: side = W, front34 = SW, back34 = NW; E, SE and NE are
// those rows mirrored.

export const ROWS = ['side', 'front', 'back', 'front34', 'back34'];

// 8-way compass index: E=0, SE=1, S=2, SW=3, W=4, NW=5, N=6, NE=7 (what goes over the wire and into the DB).
export const DIR8 = [{ row: 0, flip: true }, { row: 3, flip: true }, { row: 1, flip: false }, { row: 3, flip: false },
                     { row: 0, flip: false }, { row: 4, flip: false }, { row: 2, flip: false }, { row: 4, flip: true }];
export function dir8FromVector(dx, dy) {
  const a = Math.atan2(dy, dx) * 180 / Math.PI;
  return ((Math.round(a / 45) % 8) + 8) % 8;
}
export function rowFlipFromDir8(d) { return DIR8[((d % 8) + 8) % 8]; }

// A parked bike's stored direction as 0-7: state v20 stores the compass; an older row or client says left / right.
export function parkedFacing8(f) {
  if (Number.isInteger(f) && f >= 0 && f <= 7) return f;
  return f === 'left' ? 4 : 0;
}

// whether a side-only picture is mirrored to point that way (SW, W, NW)
export function facesLeft(f) {
  const d = parkedFacing8(f);
  return d >= 3 && d <= 5;
}
